import { Card, Page } from "@shopify/polaris";
import { useAppContext } from "../../context";
import { getParamByRole, handleError } from "../../helper";
import AmazonIdeaTemplateForm from "./amazon-idea-template-form";
import React, { useCallback } from "react";
import { useToastContext } from "../shared/ToastContext";
import { CREATE_AMAZON_IDEA_TEMPLATE } from "../../graphql/mutations/amazon-idea";
import history from "../../history";
import { useMutation } from "@apollo/react-hooks";
import useTimeout from "../../hooks/useTimeout";

export default function CreateAmazonIdeaTemplatePage() {
    const { currentUser } = useAppContext();
    const pathname = getParamByRole(currentUser);

    const { setNotify, toggleToast } = useToastContext();

    const [setDelay] = useTimeout();
    const [createAmazonIdeaTemplate, { loading }] = useMutation(CREATE_AMAZON_IDEA_TEMPLATE, {
        onCompleted: () => {
            setNotify({ msg: "Create amazon idea template successfully", err: false });

            setDelay(() => {
                history.push(`/${pathname}/amazon-idea-templates`);
            }, 1000);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const handleSubmit = useCallback(
        (input) => {
            if (!input) return;

            toggleToast && toggleToast(true);
            setNotify && setNotify({ msg: null, err: false });
            createAmazonIdeaTemplate({
                variables: {
                    input,
                },
            });
        },
        [createAmazonIdeaTemplate, setNotify, toggleToast],
    );

    return (
        <Page
            title="Create Amazon Idea Template"
            fullWidth
            breadcrumbs={[
                {
                    content: "Amazon Idea Templates",
                    url: `/${pathname}/amazon-idea-templates`,
                },
            ]}
        >
            <Card sectioned>
                <AmazonIdeaTemplateForm onSubmit={handleSubmit} loading={loading}/>
            </Card>
        </Page>
    );
}
